import React, { useState, useEffect } from 'react'
import { Table } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import GMap from '../../components/map/GMap'
import { getLocation } from '../../redux/actions/location'
import { getValueFromOptions } from '../../utils/dataUtil'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { loadLocation } from '../../components/location/Location'

export default function AreaTableView({ ...props }) {
  const { schema, isDep6 } = props
  const { Column, HeaderCell, Cell } = Table

  const [markers, setMarkers] = useState([])
  const [locationList, setLocationList] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleLocation()
  }, [])

  const handleLocation = async () => {
    setIsLoading(true)
    const location = await loadLocation()
    setLocationList(location)
    setIsLoading(false)
  }

  useEffect(() => {
    let arr = schema.area.values
    let _markers = []
    arr.map((item) => {
      let position = {
        lat: item.latitude,
        lng: item.longitude,
      }
      _markers.push(position)
    })
    setMarkers(_markers)
  }, [schema.area.values])

  const generateTable = (dataList) => {
    if (dataList) {
      let _dataList = dataList.map((item) => {
        let dataTable = item
        let valList = item.location.split('-')
        let dataObj = locationList
        let keyValue = ''
        let province = ''
        let district = ''
        let subDistrict = ''

        for (let index = 0; index < valList.length; index++) {
          if (index === 0) {
            keyValue = valList[index]
          } else {
            keyValue += '-' + valList[index]
          }

          let obj
          dataObj?.forEach((item) => {
            if (item.value === keyValue) {
              obj = item
              return
            }
          })

          if (obj) {
            switch (index) {
              case 0:
                province = obj.label
                break
              case 1:
                district = obj.label
                break
              case 2:
                subDistrict = obj.label
                break
              default:
                break
            }

            dataObj = obj.children
          }
        }

        dataTable.province = province
        dataTable.district = district
        dataTable.subDistrict = subDistrict

        return dataTable
      })
      return _dataList
    }
  }

  return (
    <>
      <p>พื้นที่ในการดำเนินการ</p>
      {!isDep6 && <GMap markers={markers} hideSearchBox={true} defaultZoom={6} />}

      <br />
      <Table height={400} data={generateTable(schema.area.values)} wordWrap>
        <Column minWidth={100} flexGrow={100}>
          <HeaderCell>{'จังหวัด'}</HeaderCell>
          <Cell dataKey={'province'} />
        </Column>

        <Column minWidth={100} flexGrow={100}>
          <HeaderCell>{'อำเภอ/เขต'}</HeaderCell>
          <Cell dataKey={'district'} />
        </Column>

        <Column minWidth={100} flexGrow={100}>
          <HeaderCell>{'ตำบล/แขวง'}</HeaderCell>
          <Cell dataKey={'subDistrict'} />
        </Column>

        <Column minWidth={100} flexGrow={100}>
          <HeaderCell>{'หมู่บ้าน'}</HeaderCell>
          <Cell dataKey={'villageName'} />
        </Column>

        <Column minWidth={100} flexGrow={100}>
          <HeaderCell>ประเภท</HeaderCell>
          <Cell>
            {(rowData) => {
              const locationType = getValueFromOptions(
                schema.area.locationType.options,
                rowData.locationType
              )
              return <span>{locationType}</span>
            }}
          </Cell>
        </Column>
      </Table>
      {isLoading && <OverlayLoader />}
    </>
  )
}
